<template>
    <form class="email-capture-form" @submit.prevent="validateFields">
        <div class="row no-gutters align-items-center">
            <div class="col-12 col-md form-group">
                <input
                    v-model="email"
                    v-validate="'required|email'"
                    data-vv-name="email"
                    data-vv-as="Email"
                    type="email"
                    required
                    class="form-control"
                    placeholder="Your Email Here"
                    data-vv-delay="250"
                >
            </div>
            <div class="col-12 col-md-auto pt-3 pt-md-0 pl-md-3">
                <slot
                    :errors="errors"
                    name="submit-btn"
                >
                    <button
                        class="btn btn-primary"
                        type="submit"
                        :class="{ 'deactivated': errors.has('email') || isLoading }"
                    >
                        Sign Up For Free
                    </button>
                </slot>
            </div>
        </div>
        <div v-if="errors.has('email')" class="row error-badge">
            <div class="col-12">
                <span>
                    {{ errors.first('email') }}
                </span>
            </div>
        </div>
    </form>
</template>

<script>
export default {
    name: "EmailCaptureForm",
    props: {
        newsletterPosition: {
            type: String,
            default() {
                return ""
            }
        }
    },
    data() {
        return {
            email: "",
            isLoading: false
        }
    },
    methods: {
        submitEmailForm() {
            if (this.isLoading) {
                return;
            }

            this.isLoading = true;
            this.$emit("isLoading", this.isLoading);

            const data = new FormData();
            data.append("email", this.email);

            if (this.newsletterPosition) {
                this.trackGTMEvent();
            }

            axiosCms({
                url: `/site/subscription/daily-insights`,
                method: "POST",
                data
            }).then(() => {
                localStorage.setItem("bi-subscribed", true);
                this.$router.push({ name: "bi-discover", params: { sourceRoute: "newsLetterSubscription" } });
            }).catch(() => {
                this.$validator.errors.add({
                    field: "email",
                    msg: "Something went wrong!."
                });
            }).finally(() => {
                this.isLoading = false;
                this.$emit("isLoading", this.isLoading);
            })
        },
        async validateFields() {
            const isFormValid = await this.$validator.validate();
            if (isFormValid) {
                this.submitEmailForm();
            }
        },
        trackGTMEvent() {
            const customEvents = {
                "newsletter-above": {
                    event: "bi-conv-landing-fnsu-atf",
                    action: "fnsu-atf"
                },
                "newsletter-below": {
                    event: "bi-conv-landing-fnsu-btf",
                    action: "fnsu-btf"
                }
            };
            const gtmEvent = {
                ...customEvents[this.newsletterPosition]
            };

            this.$_gtmTrackEvent(gtmEvent);
        }
    }
}
</script>

<style lang="scss">
.email-capture-form {
    input.form-control {
        border-radius: 6px;
        border: 0;
        height: 50px;

        &.border-danger {
            border-width: 1px;
            border-style: solid;
        }
    }

    button {
        height: 50px;
        width: 100%;
    }

    .error-badge {
        span {
            border-radius: 6px;
            background-color: #fae5e7;
            width: 100%;
            display: block;
            color: #d0021b;
            font-size: 15px;
            padding: 10px;
            margin-top: 6px;
        }
    }
}
</style>
